import { CellSelection, TableMap } from '@tiptap/pm/tables'

export const computeCellSelectionCounts = (
  selection: CellSelection
): { rowCount: number; columnCount: number } => {
  const tableNode = selection.$anchorCell.node(-1)
  const tableStart = selection.$anchorCell.start(-1)
  const map = TableMap.get(tableNode)
  const anchorRect = map.findCell(selection.$anchorCell.pos - tableStart)
  const headRect = map.findCell(selection.$headCell.pos - tableStart)
  const top = Math.min(anchorRect.top, headRect.top)
  const bottom = Math.max(anchorRect.bottom, headRect.bottom)
  const left = Math.min(anchorRect.left, headRect.left)
  const right = Math.max(anchorRect.right, headRect.right)
  return { rowCount: bottom - top, columnCount: right - left }
}
